import * as React from 'react';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type ProjectLeftPanelBottomPanelProps = {
    children: ReactChildrenGeneralType;
    className?: string;
}
function ProjectLeftPanelBottomPanel({ children, className }: ProjectLeftPanelBottomPanelProps) {
    return (
        <div className={`ProjectLeftPanel__bottom-panel ${className}`}>
            {children}
        </div>
    );
}

export default ProjectLeftPanelBottomPanel;
